import styled from 'styled-components';
import { MaxWidth } from '../../common/base';

const FeatureWrapper = styled.div`
  white-space: pre-wrap;
  padding: 100px 0;
`;

const FeatureItem = styled.div`
  position: relative;
  margin-bottom: 48px;
  padding: 0 48px;
  ${MaxWidth.sm`
    padding: 16px;
  `}
`;

const FeatureItemIcon = styled.img`
  position: relative;
  left: -16px;
  height: 114px;
  ${MaxWidth.sm`
    position: absolute;
    top: -8px;
  `}
`;

const FeatureItemDesc = styled.div`
  ${MaxWidth.sm`
    padding-left: 100px;
  `}
`;

export { FeatureWrapper, FeatureItem, FeatureItemIcon, FeatureItemDesc };
